import type {
  CreateStatementPayload,
  FinancialStatement,
  StatementType,
} from "@/features/bookkeeping/types";
import { apiFetch } from "@/lib/api";

/** Paginated list envelope: `{ success, message, data, meta }`. */
interface Envelope<T> {
  success: boolean;
  message: string;
  data: T;
}

interface ApiFinancialStatement {
  id: string;
  period_label: string;
  statement_type: StatementType;
  summary: string;
  prepared_by: number | null;
  prepared_by_name: string | null;
  created_at: string;
}

function toStatement(a: ApiFinancialStatement): FinancialStatement {
  return {
    id: a.id,
    periodLabel: a.period_label,
    statementType: a.statement_type,
    summary: a.summary ?? "",
    // Display the preparer's name (prepared_by is just the numeric user id).
    preparedBy: a.prepared_by_name ?? "",
    createdAt: a.created_at,
  };
}

/** GET /clients/:clientId/financial-statements/ */
export async function listFinancialStatements(
  clientId: string,
): Promise<FinancialStatement[]> {
  const body = await apiFetch<Envelope<ApiFinancialStatement[]>>(
    `/clients/${clientId}/financial-statements/?page_size=200`,
  );
  return body.data.map(toStatement);
}

/** POST /clients/:clientId/financial-statements/ */
export async function createFinancialStatement(
  clientId: string,
  payload: CreateStatementPayload,
): Promise<FinancialStatement> {
  const body = await apiFetch<Envelope<ApiFinancialStatement>>(
    `/clients/${clientId}/financial-statements/`,
    { method: "POST", json: payload },
  );
  return toStatement(body.data);
}
